/* tslint:disable */
/* eslint-disable */
/**
 * SONeu.WebApi | v1
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  DocumentResponse,
  FileStreamResult,
  MergeDocumentsRequest,
  MergeDocumentsResponse,
  MoveDocumentRequest,
  ProblemDetails,
  RenameDocumentRequest,
} from '../models/index';
import {
    DocumentResponseFromJSON,
    DocumentResponseToJSON,
    FileStreamResultFromJSON,
    FileStreamResultToJSON,
    MergeDocumentsRequestFromJSON,
    MergeDocumentsRequestToJSON,
    MergeDocumentsResponseFromJSON,
    MergeDocumentsResponseToJSON,
    MoveDocumentRequestFromJSON,
    MoveDocumentRequestToJSON,
    ProblemDetailsFromJSON,
    ProblemDetailsToJSON,
    RenameDocumentRequestFromJSON,
    RenameDocumentRequestToJSON,
} from '../models/index';

export interface ConvertDocumentToPdfRequest {
    clientId: string;
    documentId: string;
}

export interface DeleteDocumentsRequest {
    clientId: string;
    ids?: Array<string>;
}

export interface DownloadDocumentRequest {
    clientId: string;
    documentId: string;
}

export interface GetDocumentPreviewRequest {
    clientId: string;
    documentId: string;
}

export interface GetDocumentsFromClientDropZoneRequest {
    clientId: string;
}

export interface GetDocumentsFromClientSelfDropZoneRequest {
    clientId: string;
}

export interface MergeDocumentsOperationRequest {
    clientId: string;
    mergeDocumentsRequest: MergeDocumentsRequest;
}

export interface MoveDocumentOperationRequest {
    clientId: string;
    moveDocumentRequest: MoveDocumentRequest;
}

export interface RenameDocumentOperationRequest {
    clientId: string;
    documentId: string;
    renameDocumentRequest: RenameDocumentRequest;
}

export interface UploadDocumentToClientDropZoneRequest {
    clientId: string;
    convertToPdf?: boolean;
}

/**
 * DocumentsApi - interface
 * 
 * @export
 * @interface DocumentsApiInterface
 */
export interface DocumentsApiInterface {
    /**
     * 
     * @param {string} clientId 
     * @param {string} documentId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DocumentsApiInterface
     */
    convertDocumentToPdfRaw(requestParameters: ConvertDocumentToPdfRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>>;

    /**
     */
    convertDocumentToPdf(requestParameters: ConvertDocumentToPdfRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void>;

    /**
     * 
     * @param {string} clientId 
     * @param {Array<string>} [ids] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DocumentsApiInterface
     */
    deleteDocumentsRaw(requestParameters: DeleteDocumentsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<string>>>;

    /**
     */
    deleteDocuments(requestParameters: DeleteDocumentsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<string>>;

    /**
     * 
     * @param {string} clientId 
     * @param {string} documentId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DocumentsApiInterface
     */
    downloadDocumentRaw(requestParameters: DownloadDocumentRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<FileStreamResult>>;

    /**
     */
    downloadDocument(requestParameters: DownloadDocumentRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<FileStreamResult>;

    /**
     * 
     * @param {string} clientId 
     * @param {string} documentId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DocumentsApiInterface
     */
    getDocumentPreviewRaw(requestParameters: GetDocumentPreviewRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<FileStreamResult>>;

    /**
     */
    getDocumentPreview(requestParameters: GetDocumentPreviewRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<FileStreamResult>;

    /**
     * 
     * @param {string} clientId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DocumentsApiInterface
     */
    getDocumentsFromClientDropZoneRaw(requestParameters: GetDocumentsFromClientDropZoneRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<DocumentResponse>>>;

    /**
     */
    getDocumentsFromClientDropZone(requestParameters: GetDocumentsFromClientDropZoneRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<DocumentResponse>>;

    /**
     * 
     * @param {string} clientId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DocumentsApiInterface
     */
    getDocumentsFromClientSelfDropZoneRaw(requestParameters: GetDocumentsFromClientSelfDropZoneRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<DocumentResponse>>>;

    /**
     */
    getDocumentsFromClientSelfDropZone(requestParameters: GetDocumentsFromClientSelfDropZoneRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<DocumentResponse>>;

    /**
     * 
     * @param {string} clientId 
     * @param {MergeDocumentsRequest} mergeDocumentsRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DocumentsApiInterface
     */
    mergeDocumentsRaw(requestParameters: MergeDocumentsOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<MergeDocumentsResponse>>;

    /**
     */
    mergeDocuments(requestParameters: MergeDocumentsOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<MergeDocumentsResponse>;

    /**
     * 
     * @param {string} clientId 
     * @param {MoveDocumentRequest} moveDocumentRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DocumentsApiInterface
     */
    moveDocumentRaw(requestParameters: MoveDocumentOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>>;

    /**
     */
    moveDocument(requestParameters: MoveDocumentOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void>;

    /**
     * 
     * @param {string} clientId 
     * @param {string} documentId 
     * @param {RenameDocumentRequest} renameDocumentRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DocumentsApiInterface
     */
    renameDocumentRaw(requestParameters: RenameDocumentOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>>;

    /**
     */
    renameDocument(requestParameters: RenameDocumentOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void>;

    /**
     * 
     * @param {string} clientId 
     * @param {boolean} [convertToPdf] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DocumentsApiInterface
     */
    uploadDocumentToClientDropZoneRaw(requestParameters: UploadDocumentToClientDropZoneRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<DocumentResponse>>;

    /**
     */
    uploadDocumentToClientDropZone(requestParameters: UploadDocumentToClientDropZoneRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<DocumentResponse>;

}

/**
 * 
 */
export class DocumentsApi extends runtime.BaseAPI implements DocumentsApiInterface {

    /**
     */
    async convertDocumentToPdfRaw(requestParameters: ConvertDocumentToPdfRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['clientId'] == null) {
            throw new runtime.RequiredError(
                'clientId',
                'Required parameter "clientId" was null or undefined when calling convertDocumentToPdf().'
            );
        }

        if (requestParameters['documentId'] == null) {
            throw new runtime.RequiredError(
                'documentId',
                'Required parameter "documentId" was null or undefined when calling convertDocumentToPdf().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/api/clients/{clientId}/documents/{documentId}/convert-to-pdf`;
        urlPath = urlPath.replace(`{${"clientId"}}`, encodeURIComponent(String(requestParameters['clientId'])));
        urlPath = urlPath.replace(`{${"documentId"}}`, encodeURIComponent(String(requestParameters['documentId'])));

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async convertDocumentToPdf(requestParameters: ConvertDocumentToPdfRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.convertDocumentToPdfRaw(requestParameters, initOverrides);
    }

    /**
     */
    async deleteDocumentsRaw(requestParameters: DeleteDocumentsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<string>>> {
        if (requestParameters['clientId'] == null) {
            throw new runtime.RequiredError(
                'clientId',
                'Required parameter "clientId" was null or undefined when calling deleteDocuments().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['ids'] != null) {
            queryParameters['ids'] = requestParameters['ids'];
        }

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/api/clients/{clientId}/documents`;
        urlPath = urlPath.replace(`{${"clientId"}}`, encodeURIComponent(String(requestParameters['clientId'])));

        const response = await this.request({
            path: urlPath,
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse<any>(response);
    }

    /**
     */
    async deleteDocuments(requestParameters: DeleteDocumentsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<string>> {
        const response = await this.deleteDocumentsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async downloadDocumentRaw(requestParameters: DownloadDocumentRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<FileStreamResult>> {
        if (requestParameters['clientId'] == null) {
            throw new runtime.RequiredError(
                'clientId',
                'Required parameter "clientId" was null or undefined when calling downloadDocument().'
            );
        }

        if (requestParameters['documentId'] == null) {
            throw new runtime.RequiredError(
                'documentId',
                'Required parameter "documentId" was null or undefined when calling downloadDocument().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/api/clients/{clientId}/documents/{documentId}`;
        urlPath = urlPath.replace(`{${"clientId"}}`, encodeURIComponent(String(requestParameters['clientId'])));
        urlPath = urlPath.replace(`{${"documentId"}}`, encodeURIComponent(String(requestParameters['documentId'])));

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => FileStreamResultFromJSON(jsonValue));
    }

    /**
     */
    async downloadDocument(requestParameters: DownloadDocumentRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<FileStreamResult> {
        const response = await this.downloadDocumentRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async getDocumentPreviewRaw(requestParameters: GetDocumentPreviewRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<FileStreamResult>> {
        if (requestParameters['clientId'] == null) {
            throw new runtime.RequiredError(
                'clientId',
                'Required parameter "clientId" was null or undefined when calling getDocumentPreview().'
            );
        }

        if (requestParameters['documentId'] == null) {
            throw new runtime.RequiredError(
                'documentId',
                'Required parameter "documentId" was null or undefined when calling getDocumentPreview().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/api/clients/{clientId}/documents/{documentId}/preview`;
        urlPath = urlPath.replace(`{${"clientId"}}`, encodeURIComponent(String(requestParameters['clientId'])));
        urlPath = urlPath.replace(`{${"documentId"}}`, encodeURIComponent(String(requestParameters['documentId'])));

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => FileStreamResultFromJSON(jsonValue));
    }

    /**
     */
    async getDocumentPreview(requestParameters: GetDocumentPreviewRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<FileStreamResult> {
        const response = await this.getDocumentPreviewRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async getDocumentsFromClientDropZoneRaw(requestParameters: GetDocumentsFromClientDropZoneRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<DocumentResponse>>> {
        if (requestParameters['clientId'] == null) {
            throw new runtime.RequiredError(
                'clientId',
                'Required parameter "clientId" was null or undefined when calling getDocumentsFromClientDropZone().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/api/clients/{clientId}/documents`;
        urlPath = urlPath.replace(`{${"clientId"}}`, encodeURIComponent(String(requestParameters['clientId'])));

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(DocumentResponseFromJSON));
    }

    /**
     */
    async getDocumentsFromClientDropZone(requestParameters: GetDocumentsFromClientDropZoneRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<DocumentResponse>> {
        const response = await this.getDocumentsFromClientDropZoneRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async getDocumentsFromClientSelfDropZoneRaw(requestParameters: GetDocumentsFromClientSelfDropZoneRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<DocumentResponse>>> {
        if (requestParameters['clientId'] == null) {
            throw new runtime.RequiredError(
                'clientId',
                'Required parameter "clientId" was null or undefined when calling getDocumentsFromClientSelfDropZone().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/api/clients/{clientId}/documents/self`;
        urlPath = urlPath.replace(`{${"clientId"}}`, encodeURIComponent(String(requestParameters['clientId'])));

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(DocumentResponseFromJSON));
    }

    /**
     */
    async getDocumentsFromClientSelfDropZone(requestParameters: GetDocumentsFromClientSelfDropZoneRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<DocumentResponse>> {
        const response = await this.getDocumentsFromClientSelfDropZoneRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async mergeDocumentsRaw(requestParameters: MergeDocumentsOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<MergeDocumentsResponse>> {
        if (requestParameters['clientId'] == null) {
            throw new runtime.RequiredError(
                'clientId',
                'Required parameter "clientId" was null or undefined when calling mergeDocuments().'
            );
        }

        if (requestParameters['mergeDocumentsRequest'] == null) {
            throw new runtime.RequiredError(
                'mergeDocumentsRequest',
                'Required parameter "mergeDocumentsRequest" was null or undefined when calling mergeDocuments().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/api/clients/{clientId}/documents/merge`;
        urlPath = urlPath.replace(`{${"clientId"}}`, encodeURIComponent(String(requestParameters['clientId'])));

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: MergeDocumentsRequestToJSON(requestParameters['mergeDocumentsRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => MergeDocumentsResponseFromJSON(jsonValue));
    }

    /**
     */
    async mergeDocuments(requestParameters: MergeDocumentsOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<MergeDocumentsResponse> {
        const response = await this.mergeDocumentsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async moveDocumentRaw(requestParameters: MoveDocumentOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['clientId'] == null) {
            throw new runtime.RequiredError(
                'clientId',
                'Required parameter "clientId" was null or undefined when calling moveDocument().'
            );
        }

        if (requestParameters['moveDocumentRequest'] == null) {
            throw new runtime.RequiredError(
                'moveDocumentRequest',
                'Required parameter "moveDocumentRequest" was null or undefined when calling moveDocument().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/api/clients/{clientId}/documents/move`;
        urlPath = urlPath.replace(`{${"clientId"}}`, encodeURIComponent(String(requestParameters['clientId'])));

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: MoveDocumentRequestToJSON(requestParameters['moveDocumentRequest']),
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async moveDocument(requestParameters: MoveDocumentOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.moveDocumentRaw(requestParameters, initOverrides);
    }

    /**
     */
    async renameDocumentRaw(requestParameters: RenameDocumentOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['clientId'] == null) {
            throw new runtime.RequiredError(
                'clientId',
                'Required parameter "clientId" was null or undefined when calling renameDocument().'
            );
        }

        if (requestParameters['documentId'] == null) {
            throw new runtime.RequiredError(
                'documentId',
                'Required parameter "documentId" was null or undefined when calling renameDocument().'
            );
        }

        if (requestParameters['renameDocumentRequest'] == null) {
            throw new runtime.RequiredError(
                'renameDocumentRequest',
                'Required parameter "renameDocumentRequest" was null or undefined when calling renameDocument().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/api/clients/{clientId}/documents/{documentId}/rename`;
        urlPath = urlPath.replace(`{${"clientId"}}`, encodeURIComponent(String(requestParameters['clientId'])));
        urlPath = urlPath.replace(`{${"documentId"}}`, encodeURIComponent(String(requestParameters['documentId'])));

        const response = await this.request({
            path: urlPath,
            method: 'PATCH',
            headers: headerParameters,
            query: queryParameters,
            body: RenameDocumentRequestToJSON(requestParameters['renameDocumentRequest']),
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async renameDocument(requestParameters: RenameDocumentOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.renameDocumentRaw(requestParameters, initOverrides);
    }

    /**
     */
    async uploadDocumentToClientDropZoneRaw(requestParameters: UploadDocumentToClientDropZoneRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<DocumentResponse>> {
        if (requestParameters['clientId'] == null) {
            throw new runtime.RequiredError(
                'clientId',
                'Required parameter "clientId" was null or undefined when calling uploadDocumentToClientDropZone().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['convertToPdf'] != null) {
            queryParameters['convertToPdf'] = requestParameters['convertToPdf'];
        }

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/api/clients/{clientId}/documents/upload`;
        urlPath = urlPath.replace(`{${"clientId"}}`, encodeURIComponent(String(requestParameters['clientId'])));

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => DocumentResponseFromJSON(jsonValue));
    }

    /**
     */
    async uploadDocumentToClientDropZone(requestParameters: UploadDocumentToClientDropZoneRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<DocumentResponse> {
        const response = await this.uploadDocumentToClientDropZoneRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
